import type { ColumnDef } from '@tanstack/react-table';

import {
    type GetMicrostoreColumnTemplatesQuery,
    MicrostoreColumnTemplateState,
    MicrostoreColumnTemplateType,
} from 'data/__generated__';
import { textColumn, multiSelectColumn } from 'components/DataTable';

import { MICROSTORE_COLUMN_TEMPLATE_TYPE_LABELS, MICROSTORE_COLUMN_TEMPLATE_STATE_LABELS } from './types';
import { CommonStatusTag } from 'components/CommonStatusTag';
import { colors } from 'constants/colors';

export type MicrostoreColumnTemplateRow = GetMicrostoreColumnTemplatesQuery['microstoreColumnTemplatesQuery'][number];

type MicrostoreColumnTemplateFilterInput = {
    searchValue: string;
    state: MicrostoreColumnTemplateState[];
};

const STATE_COLORS: Record<MicrostoreColumnTemplateState, { backgroundColor: string; labelColor: string }> = {
    [MicrostoreColumnTemplateState.Regular]: {
        backgroundColor: colors.green,
        labelColor: colors.black,
    },
    [MicrostoreColumnTemplateState.Archived]: {
        backgroundColor: colors.lightGrey,
        labelColor: colors.black,
    },
};

export const microstoreColumnTemplatesColumns: ColumnDef<MicrostoreColumnTemplateRow, unknown>[] = [
    textColumn<MicrostoreColumnTemplateRow, MicrostoreColumnTemplateFilterInput>({
        accessorKey: 'name',
        header: 'Nom',
        defaultVisible: true,
    }),
    textColumn<MicrostoreColumnTemplateRow, MicrostoreColumnTemplateFilterInput>({
        accessorKey: 'type',
        header: 'Type de colonne',
        defaultVisible: true,
        cell: ({ row }) => MICROSTORE_COLUMN_TEMPLATE_TYPE_LABELS[row.original.type],
    }),
    multiSelectColumn<MicrostoreColumnTemplateRow, MicrostoreColumnTemplateFilterInput>({
        accessorKey: 'state',
        header: 'Statut',
        filterKey: 'state',
        defaultVisible: true,
        options: Object.values(MicrostoreColumnTemplateState).map((state) => ({
            value: state,
            label: MICROSTORE_COLUMN_TEMPLATE_STATE_LABELS[state],
        })),
        renderOption: (option) => {
            const state = option.value as MicrostoreColumnTemplateState;
            const { backgroundColor, labelColor } = STATE_COLORS[state];
            return (
                <CommonStatusTag
                    backgroundColor={backgroundColor}
                    labelColor={labelColor}
                    label={MICROSTORE_COLUMN_TEMPLATE_STATE_LABELS[state]}
                />
            );
        },
        cell: ({ row }) => {
            const state = row.original.state;
            const { backgroundColor, labelColor } = STATE_COLORS[state];
            return (
                <CommonStatusTag
                    backgroundColor={backgroundColor}
                    labelColor={labelColor}
                    label={MICROSTORE_COLUMN_TEMPLATE_STATE_LABELS[state]}
                />
            );
        },
    }),
];
